<template>
  <a
    v-if="reviewsCount"
    class="star-rating-link"
    href="#klaviyo-product-reviews-wrapper"
  >
    <span class="visually-hidden" v-text="$string('accessibility.reviews')" />

    <star-rating :loading="loading" :product="product" />
  </a>
</template>

<script>
/**
 * Vue: Star rating link (star-rating)
 * -----------------------------------------------------------------------------
 * Shows linked product rating (metafields).
 *
 * @param {Boolean} [loading] - Show loading state.
 * @param {Boolean|Object} [product] - Formatted product.
 *
 */
import StarRating from '~global/star-rating/star-rating';

export default {
  name: 'StarRatingLink',

  components: {
    StarRating,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    product: {
      type: [Boolean, Object],
      default: false,
    },
  },

  computed: {
    /**
     * Compute reviews count number.
     * @returns {Number}
     */
    reviewsCount() {
      return Number(this.product.reviews?.count) || 0;
    },
  },
};
</script>
